import { TabbedFilterGroup } from './TABBED_FILTERS_CONFIG';

export interface AppTopLevelCategory {
  key: string;
  label: string;
  groups?: TabbedFilterGroup[];
  permission?: string;
  hidden?: boolean;
}

export const APP_DISCOVERY_FACETS = [
  'adultContentRating',
  'ageGateDetected',
  'alcoholContentRating',
  'appContentBrandSafetyRating',
  'appDescriptionBrandSafetyRating',
  'appStore',
  'coppaRisk',
  'coppaTargetChildrenRisk',
  'drugContentRating',
  'facebookRating',
  'gamblingContentRating',
  'hasAds',
  'hasAdsTxt',
  'hasInAppPurchases',
  'hasPrivacyLink',
  'hasTermsOfServiceLink',
  'hasUserGeneratedContent',
  'hasVideoCapability',
  'hateSpeechRating',
  'isBlacklisted',
  'isExistInAppStore',
  'isIncentivizedApp',
  'isPrivateDomain',
  'linkedInRating',
  'locationMaskingRating',
  'medicalContentRating',
  'mfaRating',
  'offensiveContentRating',
  'overallIvtPermissionRisk',
  'ownerDomain',
  'pixalateRating',
  'spoofingRating',
  'topDevice',
  'topDisplayAdSize',
  'topVideoAdSize',
  'twitterRating',
  'viewabilityRating',
  'violenceContentRating',
  'vpcDetected'
];

export const APP_TOP_LEVEL_CATEGORIES: AppTopLevelCategory[] = [
  {
    key: 'app-category-toplevel-category',
    label: 'Category',
    groups: [
      {
        label: 'App Store Category',
        key: 'app-app-store-category-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'category',
            label: 'App Store Categories',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      }
    ]
  },
  {
    key: 'app-category-iab-categories',
    label: 'IAB Categories',
    groups: [
      {
        label: 'IAB Categories',
        key: 'app-category-iab-categories-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'iabPrimaryCategory',
            label: 'Primary Categories',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'iabSubCategory',
            label: 'Subcategories',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      }
    ]
  },
  {
    key: 'app-risk-toplevel-category',
    label: 'Risk',
    groups: [
      {
        label: 'Risk',
        key: 'app-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'pixalateRating',
            label: 'Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Permission Risk',
        key: 'app-permission-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'overallIvtPermissionRisk',
            label: 'Permission Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'COPPA Violation Risk',
        key: 'app-coppa-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'coppaRisk',
            label: 'COPPA Violation Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              },
              {
                name: 'Critical',
                value: 'C',
                selected: false
              }
            ],
            rangePercent: false,
            permission: 'mrtAppInsightsCoppaPermissionRisk'
          }
        ]
      },
      {
        label: 'COPPA Audience',
        key: 'app-directed-to-children-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'coppaTargetChildrenRisk',
            label: 'COPPA Audience',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'General Audience',
                value: 'L',
                selected: false
              },
              {
                name: 'Child Directed',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false,
            permission: 'mrtAppInsightsCoppaPermissionRisk'
          },
          {
            param: 'ageGateDetected',
            label: 'Age Gate Detected',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false,
            permission: 'mrtAppInsightsCoppaPermissionRisk'
          },
          {
            param: 'vpcDetected',
            label: 'VPC Detected',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false,
            permission: 'mrtAppInsightsCoppaPermissionRisk'
          }
        ]
      },
      {
        label: 'Ad Fraud Risk',
        key: 'app-ad-fraud-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'isBlacklisted',
            label: 'Blocklisted',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'isIncentivizedApp',
            label: 'Incentivized Activity',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'true',
                selected: false
              },
              {
                name: 'No',
                value: 'false',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'givtSivtRate',
            label: 'Est. IVT(%)',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 0.01,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          },
          {
            param: 'spoofingRating',
            label: 'Potential Bundle Id Spoofing Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'locationMaskingRating',
            label: 'Location Masking Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Brand Safety Risk',
        key: 'app-brand-safety-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'appDescriptionBrandSafetyRating',
            label: 'Brand Safety Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'appContentBrandSafetyRating',
            label: 'Content Brand Safety Rating',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'avgUserRating',
            label: 'Average User Rating',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 1,
            maxValue: 5,
            fromValue: 1,
            toValue: 5,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'ageGroup',
            label: 'Content Rating',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'viewabilityRating',
            label: 'Viewability Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'facebookRating',
            label: 'Facebook',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'linkedInRating',
            label: 'Linkedin',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'twitterRating',
            label: 'Twitter',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'adultContentRating',
            label: 'Adult Content Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'alcoholContentRating',
            label: 'Alcohol Content Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'drugContentRating',
            label: 'Drug Content Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'hateSpeechRating',
            label: 'Hate Speech Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'offensiveContentRating',
            label: 'Offensive Content Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'gamblingContentRating',
            label: 'Gambling Content Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'violenceContentRating',
            label: 'Violence Content Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Marketing Compliance Risk',
        key: 'app-marketing-compliance-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'hasAdsTxt',
            label: 'App-Ads.txt Detected',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: true,
            hidden: false,
            options: [
              { icon: '', text: 'Enabled', value: 'T', selected: false },
              { icon: '', text: 'Disabled', value: 'F', selected: false }
            ],
            rangePercent: false
          },
          {
            param: 'isPrivateDomain',
            label: 'WHOIS Info Hidden',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: true,
            hidden: false,
            options: [
              { icon: '', text: 'Available', value: 'T', selected: false },
              { icon: '', text: 'Not Available', value: 'F', selected: false }
            ],
            rangePercent: false
          },
          {
            param: 'hasPrivacyLink',
            label: 'Privacy Policy Detected',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'hasTermsOfServiceLink',
            label: 'Terms & Conditions Detected',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'hasUserGeneratedContent',
            label: 'User Generated Content',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      }
    ]
  },
  {
    key: 'app-mfa-toplevel-category',
    label: 'Made for Advertising (MFA)',
    groups: [
      {
        label: 'MFA Risk',
        key: 'app-mfa-rating-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'mfaRating',
            label: 'MFA Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Ad Refresh Rate',
        key: 'app-ad-refresh-rate-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'adRefreshRate',
            label: 'Ad Refresh Rate',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 50,
            fromValue: 0,
            toValue: 50,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      }
    ]
  },
  {
    key: 'app-publisher-toplevel-category',
    label: 'Publisher',
    groups: [
      {
        label: 'Publisher Details',
        key: 'app-publisher-details-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'ownerDomain',
            label: 'Owner Domain',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      }
    ]
  },
  {
    key: 'app-developer-toplevel-category',
    label: 'Developer',
    groups: [
      {
        label: 'Developer Details',
        key: 'app-developer-details-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'isExistInAppStore',
            label: 'Exist In App Store',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'developerName',
            label: 'Developer Name',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'developerEmail',
            label: 'Developer Email',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'developerCountry',
            label: 'Developer Country',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'publisherTotalApps',
            label: 'Total Apps',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      }
    ]
  },
  {
    key: 'app-app-toplevel-category',
    label: 'App',
    groups: [
      {
        label: 'Ad Capabilities',
        key: 'app-ad-capabilities-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'topDevice',
            label: 'Top Device',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'topDisplayAdSize',
            label: 'Display Top Ad Size',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'topVideoAdSize',
            label: 'Video Top Ad Size',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'hasVideoCapability',
            label: 'Has Video Capabilities',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: true,
            hidden: false,
            options: [
              { icon: '', text: 'Available', value: 'T', selected: false },
              { icon: '', text: 'Not Available', value: 'F', selected: false }
            ],
            rangePercent: false
          },
          {
            param: 'hasAds',
            label: 'Ads Detected',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'App Performance',
        key: 'app-performance-group',
        selected: false,
        collapsed: true,
        items: [
          // {
          //   param: 'adSpend',
          //   label: 'Ad Spend',
          //   previousSearchString: '',
          //   searchString: '',
          //   optionsLoading: false,
          //   optionsCount: 0,
          //   type: 'range',
          //   minValue: 0,
          //   maxValue: 100000000,
          //   fromValue: 0,
          //   toValue: 100000000,
          //   multiple: false,
          //   metadataKey: null,
          //   rangeStep: 1,
          //   hideSearch: false,
          //   hidden: false,
          //   options: [],
          //   rangePercent: false
          // },
          {
            param: 'nonGivtSivtCtr',
            label: 'CTR',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 3,
            fromValue: 0,
            toValue: 3,
            multiple: false,
            metadataKey: null,
            rangeStep: 0.01,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'hyperlocationAvailability',
            label: 'Hyperlocation(%)',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          },
          {
            param: 'hasInAppPurchases',
            label: 'In App Purchases',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: true,
            hidden: false,
            options: [
              { icon: '', text: 'Yes', value: 'T', selected: false },
              { icon: '', text: 'No', value: 'F', selected: false }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Reach',
        key: 'app-reach-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'downloads',
            label: 'Downloads',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'dailyActiveUsers',
            label: 'Est. Daily Reach',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 3000000000,
            fromValue: 0,
            toValue: 3000000000,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            labelFormat: 'big-number-no-decimal'
          },
          {
            param: 'monthlyActiveUsers',
            label: 'Est. Monthly Reach',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 3000000000,
            fromValue: 0,
            toValue: 3000000000,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            labelFormat: 'big-number-no-decimal'
          },
          {
            param: 'inventory',
            label: 'Inventory',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 10000000000,
            fromValue: 0,
            toValue: 10000000000,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            labelFormat: 'big-number'
          }
        ]
      },
      {
        label: 'Seller',
        key: 'app-seller-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'trustedSellerName',
            label: 'Trusted Seller',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Viewability',
        key: 'app-viewability-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'nonGivtSivtViewability',
            label: 'Viewability(%)',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 0.01,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          }
        ]
      },
      {
        label: 'Ad Spend',
        key: 'app-adspend-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'adSpend',
            label: 'Ad Spend',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 10000000,
            fromValue: 0,
            toValue: 10000000,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            labelFormat: 'big-number',
            permission: 'mrtAppAdSpend'
          }
        ]
      }
    ]
  }
];
